export const IDENTITY_PROVIDER = 'idp-integ.federate.amazon.com';
export const FEDERATE_CLIENT_ID = 'content-connection';
export const FEDERATE_ID_TOKEN = 'federate_id_token';
export const FEDERATE_LOGIN_PATH = '/api/oauth2/v1/authorize';

export const APP_CONFIG = {
  identityProvider: IDENTITY_PROVIDER,
  identityEndpoint: `https://${IDENTITY_PROVIDER}${FEDERATE_LOGIN_PATH}`,
  federateIdToken: FEDERATE_ID_TOKEN,
  federateClientId: FEDERATE_CLIENT_ID,
};
